
export default {
  name: 'ServiceForm',
  props: {
    /**
     * Short label for this form
     */
    name: {
      type: String,
      default: null,
    },
    /**
     * Reason of the message, from Salesforce: (Algemeen) (Adreswijziging) (Doorgeven mutatie) (Gegevens doorgeven) (Opzegging) (Overlijden)
     */
    reason: {
      validator: (prop) => {
        return Object.values(['Algemeen', 'Adreswijziging', 'Doorgeven mutatie', 'Gegevens doorgeven', 'Opzegging', 'Overlijden', 'Opinie']).includes(prop) ||
        prop === undefined ||
        prop === null
      },
      default: 'Algemeen',
    },
    /**
     * Custom subject of the message
     */
    subject: {
      type: String,
      default: null,
    },
    /**
     * The vuelidate validation instance ($v)
     */
    vuelidate: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      isVisitorGenuine: false,
      isCaptchaScriptAvailable: false,
      captchaWatcher: null,
    }
  },
  head () {
    return {
      script: [
        {
          hid: 'recaptcha-script',
          src: 'https://www.google.com/recaptcha/api.js',
          callback: () => {
            this.isCaptchaScriptAvailable = true
            this.watchCaptcha()
          },
        },
      ],
    }
  },
  computed: {
    captchaSettings () {
      return {
        keyname: this.$config.salesforce.settings.captcha.keyName,
        orgId: this.$config.salesforce.settings.organisationId,
        fallback: 'true',
        ts: '',
      }
    },
    isFormValid () {
      return this.isVisitorGenuine && !this.vuelidate.$invalid
    },
    returnUrl () {
      return `${this.$config.baseUrl}/contact/verzonden`
    },
  },
  mounted () {
    this.watchCaptcha()
  },
  activated () {
    this.watchCaptcha()
  },
  deactivated () {
    this.unwatchCaptcha()
  },
  beforeDestroy () {
    this.unwatchCaptcha()
  },
  methods: {
    watchCaptcha () {
      if (window && !this.captchaWatcher && this.isCaptchaScriptAvailable) {
        this.captchaWatcher = window.setInterval(this.getCaptchaValidation, 350)
      }
    },
    unwatchCaptcha () {
      if (window) {
        window.clearInterval(this.captchaWatcher)
        this.captchaWatcher = null
      }
    },
    getCaptchaValidation () {
      /**
       * Check if recaptcha validated and save that moment as timestamp
       */
      if (!document.querySelector('[id^=g-recaptcha-response]')) {
        this.onCaptchaInvalidated()
        return
      }

      // find status by the textarea inside the div placeholder (Salesforce-style of validating)
      const responseField = document.querySelector('[id^=g-recaptcha-response]')
      if (responseField == null || responseField.value?.trim() === '') {
        this.captchaSettings.ts = JSON.stringify(new Date().getTime())
        this.onCaptchaInvalidated()
      } else {
        this.onCaptchaValidated()
      }

      // find status by accessing window object (EO-style of validating)
      if (window && window.grecaptcha && typeof window.grecaptcha.getResponse() !== 'undefined') {
        const captchaStatus = window?.grecaptcha?.getResponse()
        if (captchaStatus && captchaStatus.length !== 0) {
          this.onCaptchaValidated()
          return
        }
      }
      this.onCaptchaInvalidated()
    },
    onCaptchaValidated () {
      if (this.isVisitorGenuine) { return }
      this.isVisitorGenuine = true
    },
    onCaptchaInvalidated () {
      if (!this.isVisitorGenuine) { return }
      this.isVisitorGenuine = false
    },
    onSubmit (e) {
      /**
       * Validate the form fields and submit
       */
      this.vuelidate.$touch()
      if (this.vuelidate.$invalid || !this.isVisitorGenuine) {
        e.preventDefault()
        return false
      } else {
        return true
      }
    },
  },
}
